import EngagementOffersModuleView from './EngagementOffersModuleView';
import { CLICK } from '../staticModule';
import {
  ENGAGEMENT_OFFERS,
  PRESCREEN_OFFERS,
} from 'types/morph.pagePosition.constants';
import { CREDIT_CARD_VERTICAL } from 'types/mrph.vertical.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import useEngagementOfferModule from './hooks/EngagementOfferModule.hook';

const EngagementOffersModuleController = props => {
  const { eventHandler, offers, history, modulePosition, additionalData } =
    props;
  const eventType = additionalData?.eventInfo?.eventType;
  const { sendPutEvenTypeFromOfferModule } =
    useEngagementOfferModule(eventType);
  const onClickSeeMore = () => {
    history.push('/offers');
    eventHandler(CLICK, {
      'Click Type': 'See all Cards',
      'Module name':
        props?.module === 'PRESCREEN_OFFERS'
          ? PRESCREEN_OFFERS
          : ENGAGEMENT_OFFERS,
    });
  };
  const moduleName =
    props?.module === 'PRESCREEN_OFFERS' ? PRESCREEN_OFFERS : ENGAGEMENT_OFFERS;
  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName:
      props?.module === 'PRESCREEN_OFFERS'
        ? PRESCREEN_OFFERS
        : ENGAGEMENT_OFFERS,
    modulePosition: modulePosition,
    vertical: CREDIT_CARD_VERTICAL,
    moduleHeading: additionalData?.eventInfo?.eventType,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);
  return (
    <EngagementOffersModuleView
      offers={offers}
      eventHandler={eventHandler}
      onClickSeeMore={onClickSeeMore}
      additionalData={additionalData}
      seenModuleTracking={seenModuleTracking}
      modulePosition={modulePosition}
      sendPutEvenTypeFromOfferModule={sendPutEvenTypeFromOfferModule}
      moduleName={moduleName}
    />
  );
};

export default EngagementOffersModuleController;
